/**
 * @fileoverview Class that contains static methods to make backend calls. These are methods that
 * are typically passed into various components and classes, which would make it possible to mock
 * IO while testing components.
 *
 * One specific point to note is that methods added here should return promises (objects with
 * .then()  and .catch()), as these would provide a standardized way of managing asynchronous
 * control flow in both the main and test code.
 *
 *
 * @author Varun Vijayaraghavan (vvijayaraghavan@yext.com)
 */

goog.module('yext.m4.confcode.adminconsole.Repositories');

const routes = goog.require('yext.m4.confcode.adminconsole.routes');

class Repositories {
  /**
   * @param {!number} businessId
   * @param {string|undefined} sessionId
   * @return {!Promise}
   */
  static checkBusinessAccess(businessId, sessionId) {
    // TODO (varun): Should try and replace with the standard fetch API.
    //  But currently getting a 403 with the default options there.
    return Repositories._promisifyXhr($.ajax({
      method: 'POST',
      url: routes.AdminConsole.checkBusinessAccess({}),
      data: {
        'businessId': businessId,
        'sessionId': sessionId,
      },
    }));
  }

  /**
   * @param {!number} businessId
   * @param {string|undefined} sessionId
   * @return {!Promise}
   */
  static completeSession(businessId, sessionId) {
    return Repositories._promisifyXhr($.ajax({
      method: 'GET',
      url: routes.AdminConsole.completeSession({}),
      data: {
        'businessId': businessId,
        'sessionId': sessionId,
        'shouldRedirectToAdminConsole': false,
      },
    }));
  }

  /**
   * @param {!jQuery.jqXHR} jqXhrObj
   * @return {!Promise}
   * @private
   */
  static _promisifyXhr(jqXhrObj) {
    return new Promise((resolve, reject) => {
      jqXhrObj
        .done(data => resolve(data))
        .fail((jqXHR, textStatus, errorThrown) => {
          reject(errorThrown);
        });
    });
  }
}

exports = Repositories;
